<template>
<div class='title'>
  <span>{{title}}</span>
</div>
</template>

<script>
export default {
  props:['title']
}
</script>

<style scoped lang="scss">
.title{
  margin-bottom: 10px;
  font-size: 14px;

  font-weight: bold;
}
</style>